import { Theme } from '@mui/material';

export const styles = {
  messageImageItemSecond: (aspectRatio?: number) => ({
    aspectRatio: aspectRatio ? aspectRatio : 16 / 9,
    width: '100%',
    height: '100%',
    position: 'relative',
  }),
  imageMockWrapper: (theme: Theme) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '24px',
    backgroundColor: theme.palette.action.disabledBackground,
    background: `linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      ${theme.palette.common.surface['surface 44']} 50%,
      rgba(255, 255, 255, 0) 60%
    ) ${theme.palette.action.disabledBackground}`,
    backgroundSize: '200% 100%',
    backgroundPositionX: '180%',
  }),
  loader: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
    height: '100%',
    padding: '20px',
  },
  deletedImage: {
    width: '100%',
    padding: '10px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
  },
  imageErrorWrapper: (theme: Theme) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    overflow: 'hidden',
    borderRadius: '24px',
    backgroundColor: theme.palette.action.disabledBackground,
    '& > div': {
      transform: 'translate(-50%, -50%)',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      '@media (min-width: 1500px) and (max-width: 1700px)': {
        gap: '5px',
      },
    },
  }),
  imageOverlay: (theme: Theme) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: theme.palette.common.black,
    borderRadius: '24px',
    opacity: 0,
    transition: 'all 0.3s ease-in-out',
    pointerEvents: 'none',
  }),
  eye: {
    opacity: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    transition: 'all 0.3s ease-in-out',
    pointerEvents: 'none',
  },
  imageWrapper: (theme: Theme) => ({
    display: 'flex',
    borderRadius: '24px',
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
    width: '100%',
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    '& img': {
      transition: 'all 0.3s ease-in-out',
    },
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        '& img': {
          transform: 'scale(1.1)',
        },
        '& div:first-of-type': {
          // opacity: 0.4,
        },
        '& div:last-of-type': {
          opacity: 1,
        },
      },
    },
  }),
  imageSwap: {
    top: '50%',
    transform: 'translateY(-50%)',
    '& img': {
      objectFit: 'cover',
    },
  },
};
